<template>
  <div class="cmi-resource-view">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <h3 class="header">AUDIO MESSAGES</h3>
        </div>
      </div>
      <div class="panel-body">
        <div class="panel panel-info cmi-search-header-panel">
          <div class="row cmi-search-wrapper">
            <div class="col-md-8 col-md-offset-2">
              <div class="cmi-search-header">
                <div class="row cmi-search-header-row">
                  <div class="col-md-4 header-left">
                    <span>Filter by date</span>
                  </div>
                  <div class="col-md-6 header-middle">
                    <select
                      id="filterLabel"
                      name="filterLabel"
                      @change="getFormDataByLabel"
                      v-model.trim="res_FilterLabel"
                      class="form-control"
                    >
                      <option></option>
                      <option
                        v-for="item in resourceLabels"
                        v-bind:value="item.label"
                        :key="item.label"
                        >{{ item.label }}</option
                      >
                    </select>
                  </div>
                  <div class="col-md-2 header-right">
                    <span
                      v-if="aniLabelsLoading"
                      class="fa fa-spinner fa-spin fa-3x fa-fw"
                    ></span>
                  </div>
                </div>
                <div class="row cmi-search-header-row">
                  <div class="col-md-4 header-left">
                    <span>Filter by price</span>
                  </div>
                  <div class="col-md-6 header-middle">
                    <select
                      id="filterPrice"
                      name="filterPrice"
                      @change="getFormDataByPriceType"
                      v-model.trim="res_FilterPrice"
                      class="form-control"
                    >
                      <option></option>
                      <option value="97">All</option>
                      <option value="2">Buy Now</option>
                      <option value="1">Free</option>
                    </select>
                  </div>
                  <div class="col-md-2 header-right">
                    <span
                      v-if="aniPriceTypeLoading"
                      class="fa fa-spinner fa-spin fa-3x fa-fw"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row clearfix-res">
        <transition-group
          name="animate-resource"
          @afterEnter="itemAfterEnter"
          enter-active-class="animated lightSpeedIn"
          leave-active-class="animated zoomOut"
        >
          <div
            v-for="item in resourceItems"
            v-bind:key="item.pkey"
            class="col-sm-6"
          >
            <div class="widget cmi-widget">
              <div
                class="sermon-widget"
                v-bind:data-showplayer="
                  item.res_PriceType == 1 || item.res_IntroFilePath
                "
              >
                <div class="sermon-img">
                  <img
                    v-bind:src="item.res_FileThumbnailPath"
                    alt="audio cover image"
                  />
                  <span
                    ><i class="fa fa-calendar-o"></i
                    >{{ item.res_MessageLabel }}</span
                  >
                  <h3>
                    <a href="#" title="">{{ item.res_Person }}</a>
                  </h3>
                </div>
                <div class="sermon-detail">
                  <p class="sermon-description">
                    <span class="sermon-title">Date: </span
                    ><span class="sermon-text">{{ item.res_MessageDate }}</span>
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Event: </span
                    ><span class="sermon-text">{{ item.res_Event }}</span>
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Title: </span
                    ><span class="sermon-text">
                      {{ item.res_MessageTitle }}</span
                    >
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Series: </span>
                    <span class="sermon-text">{{ item.res_MessageGenre }}</span>
                  </p>

                  <p class="sermon-description">
                    <span class="sermon-title">Audio file name: </span
                    ><span class="sermon-text">{{ item.res_FileName }}</span>
                  </p>
                  <p class="sermon-description">
                    <span class="sermon-title">Item ID: </span
                    ><span class="sermon-text">{{ item.resCode }}</span>
                  </p>
                  <p
                    v-if="item.res_MessageCommentary"
                    class="sermon-commentary"
                  >
                    <span class="sermon-commentary-title">Commentary :</span>
                    {{ item.res_MessageCommentary }}
                  </p>
                  <div
                    v-if="item.res_PriceType == 2 && item.res_IntroFilePath"
                    class="cmi-sermon-free"
                  >
                    <div class="audio-preview-title-wrapper">
                      <span class="audio-preview-title">Audio preview</span>
                    </div>
                    <div class="cmi-sermon-player-wrapper">
                      <audio
                        class="cmi-audio-player"
                        v-bind:src="item.res_IntroFilePath"
                      ></audio>
                    </div>
                  </div>
                  <div
                    v-if="item.res_PriceType == 2"
                    class="cmi-sermon-purchase"
                  >
                    <div class="cmi-price-wrapper">
                      <span class="cmi-price badge">{{
                        item.res_PriceLabel
                      }}</span>
                    </div>
                    <div class="cmi-addto-basket">
                      <button
                        @click="addToBasketLocal(item)"
                        type="button"
                        class="btn btn-primary btn-lg"
                      >
                        <span class="fa fa-shopping-cart"></span
                        ><span class="cmi-addto-text">Add to Basket</span>
                      </button>
                    </div>
                  </div>
                  <div v-if="item.res_PriceType == 1" class="cmi-sermon-free">
                    <div class="cmi-price-wrapper">
                      <span class="cmi-price badge">free download</span>
                    </div>
                    <div class="cmi-sermon-player-wrapper">
                      <audio
                        class="cmi-audio-player"
                        v-bind:src="item.res_FilePath"
                      ></audio>
                    </div>
                    <ul class="sermon-media">
                      <li>
                        <a
                          v-bind:href="item.res_FileDownloadLink"
                          title="download audio"
                          ><i class="fa fa-download"></i
                        ></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <modal
      name="alert-item"
      :width="300"
      :height="'auto'"
      :clickToClose="false"
    >
      <div class="panel-primary">
        <div class="panel-heading modal-alert-heading">
          <span class="modal-alert-title">Information</span>
          <button
            @click="closeAlertDialog"
            type="button"
            class="close pull-right"
          >
            <span
              class="fa fa-times-circle modal-alert-close-button-icon"
            ></span>
          </button>
        </div>
        <div class="panel-body modal-alert-body">
          <div class="modal-alert-text-wrapper">
            <span class="fa fa-exclamation-circle modal-alert-icon"></span>
            <span class="modal-alert-text">
              {{ alertMessage }}
            </span>
          </div>
          <div class="modal-alert-footer">
            <button
              @click="closeAlertDialog"
              type="button"
              class="btn btn-success"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      alertMessage: "",
      aniLabelsLoading: false,
      aniPriceTypeLoading: false,
      resourceLabels: [],
      resourceItems: [],
      res_FilterLabel: "",
      res_FilterPrice: ""
    };
  },
  methods: {
    ...mapActions(["getToken"]),
    ...mapMutations(["addToBasket"]),
    getResourceLabels: async function() {
      this.aniLabelsLoading = true;
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceLabels`;
      try {
        ({ data: rData } = await axios.get(actionUrl));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        this.resourceLabels = rData;
        if (this.resourceLabels.length > 0) {
          this.res_FilterLabel = this.resourceLabels[0].label;
        }
        await this.getFormDataByLabel();
      }
      this.aniLabelsLoading = false;
    },

    getFormDataByLabel: async function() {
      this.res_FilterPrice = "";
      if (!this.res_FilterLabel) {
        this.resourceItems = [];
        return;
      }
      this.aniLabelsLoading = true;
      const config = {
        params: { dateLabel: this.res_FilterLabel }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceDataByLabel`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniLabelsLoading = false;
        throw error;
      }
      if (rData) {
        this.resourceItems = rData;
      }
      this.aniLabelsLoading = false;
    },

    getFormDataByPriceType: async function() {
      this.res_FilterLabel = "";
      if (!this.res_FilterPrice) {
        this.resourceItems = [];
        return;
      }
      this.aniPriceTypeLoading = true;
      const config = {
        params: { id: this.res_FilterPrice }
      };
      let rData = null;
      let actionUrl = `${this.baseUrl}GetResourceDataByPriceType`;
      try {
        ({ data: rData } = await axios.get(actionUrl, config));
      } catch (error) {
        this.aniPriceTypeLoading = false;
        throw error;
      }
      if (rData) {
        this.resourceItems = rData;
      }
      this.aniPriceTypeLoading = false;
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-item");
    },
    itemAfterEnter: function(el) {
      let pt = window
        .$(el)
        .find(".sermon-widget")
        .data("showplayer");
      if (pt == true) {
        window
          .$(el)
          .find(".cmi-audio-player")
          .mediaelementplayer();
      }
    },
    addToBasketLocal: function(item) {
      if (!this.$store.state.basket.some(p => p.pkey == item.pkey)) {
        this.addToBasket(item);
        this.alertMessage = "Item added to your basket";
        this.$modal.show("alert-item");
      } else {
        this.alertMessage = "This item is already in your basket";
        this.$modal.show("alert-item");
      }
    }
  },
  async mounted() {
    await this.getResourceLabels();
  }
};
</script>
